import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

//defines which balance is used for which masses.
const getMeasuredUsingConfig = (prefix: string) => {
  const preparationBalance = wrap(`${prefix}.Preparation.Balance`);

  const plasticBalance = wrap(`${prefix}.PlasticLimit.Balance`);
  const plasticDryMassBalance = wrap(`${prefix}.PlasticLimit.DryMassBalance`);

  const liquidBalance = wrap(`${prefix}.LiquidLimit.Balance`);
  const liquidDryMassBalance = wrap(`${prefix}.LiquidLimit.DryMassBalance`);

  const liquidLimitOvenDriedBalance = wrap(`${prefix}.LiquidLimitOvenDried.Balance`);
  const liquidLimitOvenDriedDryMassBalance = wrap(`${prefix}.LiquidLimitOvenDried.DryMassBalance`);

  return {
    [`${prefix}.Preparation.OriginalSampleMass`]: preparationBalance,
    [`${prefix}.Preparation.PassingPortionMass`]: preparationBalance,
    [`${prefix}.Preparation.TareMass`]: preparationBalance,
    [`${prefix}.Preparation.TareAndTotalSampleWetMass`]: preparationBalance,
    [`${prefix}.Preparation.TareMassRetained`]: preparationBalance,
    [`${prefix}.Preparation.TareAndDryMassRetained`]: preparationBalance,

    [`${prefix}.PlasticLimit.Trials.MoistureDetermination.DryingTray.ContainerMass`]: plasticBalance,
    [`${prefix}.PlasticLimit.Trials.MoistureDetermination.DryingTray.WetSoilAndContainerMass`]: plasticBalance,
    [`${prefix}.PlasticLimit.Trials.MoistureDetermination.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: plasticDryMassBalance,

    [`${prefix}.LiquidLimit.Trials.MoistureDetermination.DryingTray.ContainerMass`]: liquidBalance,
    [`${prefix}.LiquidLimit.Trials.MoistureDetermination.DryingTray.WetSoilAndContainerMass`]: liquidBalance,
    [`${prefix}.LiquidLimit.Trials.MoistureDetermination.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: liquidDryMassBalance,

    [`${prefix}.LiquidLimitOvenDried.Trials.MoistureDetermination.DryingTray.ContainerMass`]: liquidLimitOvenDriedBalance,
    [`${prefix}.LiquidLimitOvenDried.Trials.MoistureDetermination.DryingTray.WetSoilAndContainerMass`]: liquidLimitOvenDriedBalance,
    [`${prefix}.LiquidLimitOvenDried.Trials.MoistureDetermination.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: liquidLimitOvenDriedDryMassBalance,
  };
};

export default getMeasuredUsingConfig;
